import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The norm",
  "description": "",
  "published": "2007-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/the-norm/swizec/327"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As is the norm with fixing bugs it took longer than anticipated. Right now the website has all the software updated and the nifty stuff added, except for some interesting bugs (like why the comments system only works for comics) and some slovene language files it works as expected. All the content will be going back up soon.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      